import { useMutation } from '@tanstack/react-query'

import { ReactQueryHttpError, V1Model, V2Model } from '@sparkai/shared-types'

import { apiClient } from '../apiClient'

type AssignedTaskResponse = V1Model | V2Model

export function useAssigned(
  onSuccess: (data: AssignedTaskResponse) => void,
  onError: (err: ReactQueryHttpError) => void
) {
  return useMutation<AssignedTaskResponse>({
    mutationFn: async () => {
      const { data } = await apiClient.get<AssignedTaskResponse>(`/int/v3/tasks/assigned`)
      return data
    },
    onSuccess,
    onError,
  })
}
